import VideoEndscreen from './VideoEndscreen';

export default VideoEndscreen;
